/**
 * AudioWorklet processor as a source string, registered from a blob URL so nothing has to be
 * hosted. It converts the mono input to little-endian 16-bit PCM at the context's own sample
 * rate (declared to the provider, so no resampling) and posts roughly 100 ms per message as a
 * transferred buffer. Self-contained: no imports or closures over module scope.
 */
export const PCM_TAP_PROCESSOR = "z-dictation-pcm-tap";

export const PCM_TAP_SOURCE = `
class PcmTap extends AudioWorkletProcessor {
  constructor() {
    super();
    this.chunkSamples = Math.round(sampleRate / 10);
    this.buffer = new Int16Array(this.chunkSamples);
    this.filled = 0;
    this.stopped = false;
    this.port.onmessage = (event) => {
      if (event.data === "stop") this.stopped = true;
    };
  }
  process(inputs) {
    if (this.stopped) return false;
    const channel = inputs[0] && inputs[0][0];
    if (!channel) return true;
    for (let i = 0; i < channel.length; i++) {
      const sample = Math.max(-1, Math.min(1, channel[i]));
      this.buffer[this.filled++] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
      if (this.filled === this.chunkSamples) {
        const out = this.buffer.buffer;
        this.port.postMessage(out, [out]);
        this.buffer = new Int16Array(this.chunkSamples);
        this.filled = 0;
      }
    }
    return true;
  }
}
registerProcessor("${PCM_TAP_PROCESSOR}", PcmTap);
`;
